const textarea: HTMLInputElement = document.querySelector(".c-talk__input--message")!;
const placeholder: HTMLElement = document.querySelector(".c-talk__input--message__placeholder")!;
if (textarea) {

  textarea.addEventListener("input", () => {
    let textLength = textarea.value.length;
    if(textLength !== 0) {
      placeholder.classList.add("c-talk__input--message__placeholder--none");
    } else {
      placeholder.classList.remove("c-talk__input--message__placeholder--none");
    }
  })

}
